<template>
    <div class="chat-overlay">
        <div class="close" @click="close">
            <CloseIcon/>
        </div>
	    <div class="leaveChat" @click="leaveChat" :class="{'no-key': typeof alias === 'undefined'}">
            <DeleteIcon/>
	    </div>
        <div v-if="typeof alias !== 'undefined'" class="showKeyButton" @click="showKey">
            <KeyIcon/>
        </div>
        <div class="goToOverview" @click="goToOverview">
            <BackIcon/>
        </div>
        <div class="dialog" ref="dialog" @scroll="updateDialogPosition">
	        <div class="is-typing" v-if="isTypingString !== ''"><span class="names">{{isTypingString}}</span> skriver...</div>
	        <div class="sequences" ref="sequences">
		        <template v-for="(sequence,index) in sequences">
			        <ChatDialogSequence v-if="sequence.user !== 'system'" :user="currentRoom.participants[sequence.user]" :key="index" :messages="sequence.messages" :from="currentRoom.tokenId === sequence.user" />
			        <p v-else v-for="message in buildSystemsSequence(sequence)">{{message}}</p>
		        </template>
		        <p v-if="showCounterpartOffline">Kræmmeren er offline. De svarer måske ikke med det samme.</p>
	        </div>
        </div>
        <div v-if="unreadMessages > 0" class="new-messages" @click="$refs['dialog'].scrollTop = $refs['sequences'].offsetHeight + 30">{{unreadMessages}} {{messagesString}}</div>
        <div class="msg">
            <textarea v-model="message" placeholder="Skriv her..." @keydown.enter.exact.prevent @keyup.enter.exact="createMessage" />
            <button @click="createMessage">SEND</button>
        </div>
        <Popup mode="showkey" :open="showkey" @closePopup="showkey = false">
            <h2>Del din chat med vennerne</h2>
            <p>Giv dine venner nedenstående nøgle og bed dem logge ind – så kan I være sammen – hver for sig – på Vorbasse Hjemme Marked. God fest!</p>
            <div class="alias" v-clipboard="alias" v-clipboard:success="clipboardSuccessHandler" v-clipboard:error="clipboardErrorHandler">
                {{alias}}
                <transition name="fade">
                    <Bubble v-if="showBubbleIsCopied" type="bottom">Nøglen er nu kopieret</Bubble>
                </transition>
            </div>
            <p class="small">Klik på nøglen ovenfor, så vil den automatisk kopiere til din udklipsholder.</p>
        </Popup>
    </div>
</template>
<script>
	import CloseIcon from "@/assets/icons/close.svg"
	import KeyIcon from "@/assets/icons/key.svg"
	import BackIcon from "@/assets/icons/back.svg"
	import DeleteIcon from "@/assets/icons/delete.svg"
	import {mapState} from "vuex";
	import ChatDialogSequence from "@/components/chat/ChatDialogSequence";
	import {isJsonString} from "@/helperFunctions";
	import Popup from "@/components/popup/Popup";
	import Bubble from "@/components/Bubble";
	let maySendTypingEvent = true;
	let tokenTimeouts = {};
    export default {
	    components: {
		    Bubble,
		    Popup,
		    ChatDialogSequence,
		    CloseIcon,
		    KeyIcon,
		    BackIcon,
		    DeleteIcon
	    },
        data(){
	    	return{
			    message: '',
                showkey: false,
                showBubbleIsCopied: false,
			    dialogIsInBottom: true,
			    isTyping: [],
			    hasReceivedCounterPartEvent: false
            }
        },
	    computed: {
		    ...mapState('vorbasse', {
			    currentRoom: 'currentRoom',
			    rooms: 'rooms'
		    }),
		    messagesCount(){
		        return this.currentRoom.messages.length;
		    },
		    isTypingString(){
		    	const that = this;
		        let string = '';
		        this.isTyping.forEach(user => {
		        	if(typeof that.currentRoom.participants[user] !== 'undefined' && user !== that.currentRoom.tokenId)
			            string += that.currentRoom.participants[user].displayName.split(' ')[0]+', ';
		        });

		        return (string !== '') ? string.slice(0, -2) : string;
		    },
            alias(){
	            return this.rooms[this.currentRoom.room].alias;
            },
		    unreadMessages(){
		        return Number(this.rooms[this.currentRoom.room].unreadMessages);
		    },
		    messagesString(){
			    return (this.unreadMessages > 1) ? "nye beskeder" : "ny besked"
		    },
		    sequences(){
			    let sequences = [];
			    let currentUser = false;
			    for(let i = 0; i < this.currentRoom.messages.length; i++)
			    {
				    const message = this.currentRoom.messages[i];
				    if(message.user !== currentUser)
				    {
					    sequences.push({
						    user:message.user,
						    messages:[]
					    });
					    currentUser = message.user;
				    }
				    sequences[sequences.length-1].messages.push(message.message)
			    }
			    return sequences;
		    },
		    counterPartPublicId(){
			    return Object.keys(this.currentRoom.participants).find((publicId) => {return publicId !== this.currentRoom.tokenId;});
		    },
		    showCounterpartOffline(){
		    	if(this.currentRoom.type !== 'kraemmerSale')
		    		return false;
			    
		    	return this.hasReceivedCounterPartEvent === false && this.counterPartPublicId !== null && typeof this.currentRoom.lastActivity[this.counterPartPublicId] !== 'undefined' && this.currentRoom.lastActivity[this.counterPartPublicId] < (new Date().getTime() - 60*1000);
		    }
	    },
		methods: {
			clipboardSuccessHandler ({ value, event }) {
                let that = this
                this.showBubbleIsCopied = true
                setTimeout(function(){
                	that.showBubbleIsCopied = false
                }, 2000)
			},
			clipboardErrorHandler ({ value, event }) {
				console.log('error', value)
			},
            close(){
            	this.$emit("closeDialog")
            },
			leaveChat(){
            	this.$store.dispatch('vorbasse/showPrompt',{
            		title: 'Er du sikker?',
            		prompt: 'Du vil forlade denne samtale, og kan ikke genoptage den uden at skrive koden ind igen - er du sikker?',
		            confirmText: 'Ja, fortsæt'
	            })
				.then(result => {
					this.$vorbasseSocket.emit('leave-room',this.currentRoom.room);
					this.$emit("closeDialog");
				})
			},
			showKey(){
				this.showkey = true
            },
			goToOverview(){
				this.$emit("closeDialog")
                this.$emit('goBackFromDialog')
            },
			createMessage(){
                if(this.message !== ''){
	                this.$vorbasseSocket.emit('chat-message',{room:this.currentRoom.room,message:this.message})
	                this.message = '';
                }
			},
			updateDialogPosition(){
            	const dialogScroll = this.$refs['dialog'].scrollTop;
            	const dialogHeight = this.$refs['dialog'].offsetHeight;
            	const sequencesHeight = this.$refs['sequences'].offsetHeight;
            	const isInBottom = (dialogScroll+dialogHeight-sequencesHeight-15) === 0;
            	if(isInBottom !== this.dialogIsInBottom)
            		this.dialogIsInBottom = isInBottom;
			},
			buildSystemsSequence(incomming){
            	let sequence = [];
            	const that = this;
				incomming.messages.forEach(message => {
					const json = message.replace(/&quot;/g,'"');
					if(isJsonString(json))
					{
						const payload = JSON.parse(json);
						if(typeof payload.type !== 'undefined')
						{
							if(payload.type === 'user_left' && typeof payload.id !== 'undefined' && typeof that.currentRoom.participants[payload.id] !== 'undefined')
							{
								sequence.push(that.currentRoom.participants[payload.id].displayName.split(' ')[0] + ' forlod samtalen');
							}
							else if(payload.type === 'user_joined' && typeof payload.id !== 'undefined' && typeof that.currentRoom.participants[payload.id] !== 'undefined')
							{
								sequence.push(that.currentRoom.participants[payload.id].displayName.split(' ')[0] + ' kom ind i samtalen');
							}
							else if(payload.type === 'chat_closed')
							{
								sequence.push('Det er en handel! - Samtalen er blev markeret som handel og afsluttet.');
							}
						}
					}
				})
				return sequence;
			}
        },
	    created()
	    {
	    	const that = this;
	    	this.$vorbasseSocket.listen('is-typing',(payload) => {
			    if(this.currentRoom.type === 'kraemmerSale' && payload.participant === this.counterPartPublicId)
				    this.hasReceivedCounterPartEvent = true;
	    		
	    	    if(that.isTyping.indexOf(payload.participant) === -1)
			        that.isTyping.push(payload.participant);

			    clearTimeout(tokenTimeouts[payload.participant]);
			    tokenTimeouts[payload.participant] = setTimeout(() => {
			        const index = that.isTyping.indexOf(payload.participant);
			        if(index !== -1)
			            that.isTyping.splice(index,1);
			    },2000)
		    })
	    },
	    destroyed()
	    {
	    	this.$vorbasseSocket.stopListening('is-typing');
	    },
	    mounted(){
	        if(this.unreadMessages !== 0)
	        {
		        const payload = {
			        room: this.currentRoom.room,
			        unreadMessages: 0
		        };
		        this.$store.commit('vorbasse/updateRooms',[payload]);
		        this.$vorbasseSocket.emit('update-room-meta',payload)
	        }
	    },
	    watch: {
		    messagesCount:{
			    handler: function(to,from)
			    {
			    	const lastMessage = this.currentRoom.messages[this.currentRoom.messages.length-1];
				    const index = this.isTyping.indexOf(lastMessage.user);
				    if(index !== -1)
					    this.isTyping.splice(index,1);
			    },
			    deep: true
		    },
	    	message(to){
	    	    if(to !== '' && maySendTypingEvent)
		        {
		        	maySendTypingEvent = false;
		        	setTimeout(() => {
				        maySendTypingEvent = true;
			        },1000)
			        this.$vorbasseSocket.emit('is-typing',this.currentRoom.room)
		        }
		    },
		    dialogIsInBottom(to){
		        if(to === true && this.unreadMessages !== 0){
		        	const payload = {
				        room: this.currentRoom.room,
				        unreadMessages: 0
			        };
			        this.$store.commit('vorbasse/updateRooms',[payload]);
			        this.$vorbasseSocket.emit('update-room-meta',payload)
		        }
		    },
		    unreadMessages(to){
		        if(this.dialogIsInBottom === true && to !== 0)
		        {
			        const payload = {
				        room: this.currentRoom.room,
				        unreadMessages: 0
			        };
			        this.$store.commit('vorbasse/updateRooms',[payload]);
			        this.$vorbasseSocket.emit('update-room-meta',payload)
		        }
		    }
	    }
    }
</script>
<style lang="scss">
    .chat-overlay{
        position: fixed;
        top: 0; left: auto;
        right: 0; bottom: 0;
        width: 100%; height: 100%;
        background: rgba(0,0,0,0.6);
        max-width: 500px;
        .close, .showKeyButton, .leaveChat, .goToOverview{
            position: absolute;
            top: 30px;
            right: 15px;
            width: 43px;
            height: 43px;
            background: $white;
            border-radius: 50%;
            cursor: pointer;
            z-index: 1;
            box-shadow: 0px 0px 25px rgba(0,0,0,0.5);
            svg{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
            }
        }
        .showKeyButton{
            right: 70px;
        }
        .goToOverview{
            right: auto;
            left: 15px;
            background: $orange;
            svg{
                left: 45%;
                path{
                    stroke: $white;
                }
            }
        }
	    .leaveChat{
            right: 125px;
            &.no-key{
                right: 70px;
            }
	    }
        .dialog{
            height: calc(100% - 96px);
            overflow-y: auto;
            display: flex;
            flex-direction: column-reverse;
            padding: 15px;
	        .is-typing{
		        margin-top:10px;
		        color: $white;
                font-size: 14px;
                padding-left: 15px;
		        .names{
			        font-weight: bold;
		        }
	        }
        }
        .new-messages{
            position: absolute;
            bottom: 120px;
            left: calc(50% - 60px);
            width: 120px;
            padding: 5px;
            font-size: 12px;
            font-weight: bold;
            color: $white;
            background: $orange;
            border-radius: 12px;
            text-align: center;
            cursor: pointer;
            display: block;
            box-shadow: 0px 0px 35px rgba(0,0,0,0.25);
        }
        .msg{
            position: absolute;
            bottom: 0px;
            left: 0px;
            width: 100%;
            box-shadow: 0px -5px 25px rgba(0,0,0,0.2);
            textarea{
                display: block;
                width: 100%;
                height: 96px;
                border: none;
                box-shadow: none;
                appearance: none;
                border-radius: 0;
                padding: 20px 100px 20px 30px;
                font-size: 14px;
                line-height: 1.35em;
                color: $dark;
                font-family: $font;
                outline: none;
            }
            button{
                width: 62px;
                height: 62px;
                padding: 0px;
                color: $white;
                background: $green;
                font-size: 14px;
                font-weight: bold;
                border: none;
                border-radius: 50%;
                position: absolute;
                top: 15px;
                right: 20px;
            }
        }
    }
</style>
